import styled from 'styled-components'
import { Color } from 'root-constants'

export const StyledFeelNervousDetailed = {
  Title: styled.div`
    margin: 24px 0 40px;
    font-weight: 500;
    font-size: 24px;
    line-height: 33px;
    color: ${Color.WHITE};
  `,
  SelectedOption: styled.div`
    margin-bottom: 40px;
    padding: 14px 20px;
    border: 1px solid ${Color.WHITE};
    background: ${Color.WHITE};
    border-radius: 16px;

    & > span {
      display: list-item;
      margin-left: 16px;
      font-weight: 500;
      font-size: 17px;
      line-height: 24px;
      color: ${Color.DARK};
    }
  `,
  Details: styled.div`
    p {
      margin-bottom: 32px;
    }
  `,
}
